// eslint-disable-next-line import/no-cycle
import ExportCalendar from './ExportCalendar';

export default ExportCalendar;
